import { isActiveTrial, isInactive, isNotRetrialEligible } from 'lib/client/360-subscriptions'
import Anchor from 'lib/components/Anchor/Anchor'
import AuthContext from 'lib/context/AuthContext'
import SubContext from 'lib/context/SubContext'
import { isLoggedIn } from 'lib/util/self'
import { freeTrialUrl, purchase360Url } from 'lib/util/urls'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import AccountDropdown from './AccountDropdown'

export default function UserData() {
  const { self } = useContext(AuthContext)
  const userSubStatus = useContext(SubContext)
  const [t] = useTranslation()

  if (self.loading) {
    return null
  }

  if (isLoggedIn(self)) {
    const shouldRenderSubscribeButton =
      (isInactive(userSubStatus) && isNotRetrialEligible(userSubStatus)) ||
      (userSubStatus.adminRole && isActiveTrial(userSubStatus.adminRole))

    return (
      <div className="header__user-data">
        {shouldRenderSubscribeButton && (
          // TODO analytic event with tracking code
          <Anchor className="header__subscribe-button" href={purchase360Url()}>
            {t('header.subscribe')}
          </Anchor>
        )}
        <AccountDropdown />
      </div>
    )
  }

  return (
    <Anchor className="header__user-data" href={freeTrialUrl()}>
      {t('header.startFreeTrial')}
    </Anchor>
  )
}
